export const formatCurrency = (value) =>
  new Intl.NumberFormat('pt-br', {
    style: 'currency',
    currency: 'brl'
  }).format(value)

export const formatDecimal = (value) =>
  new Intl.NumberFormat('pt-br').format(value)

export const formatInteger = (value) =>
  new Intl.NumberFormat('pt-br', {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2
  })
    .format(value)
    .slice(0, -3)
